import { useTranslation } from "react-i18next";
import { Log } from "../../utils/models/Log";
import "./LogPreview.scss";

type Dict = Record<string, any>;

const toRows = (before?: Dict | null, after?: Dict | null) => {
    const keys = Array.from(new Set([
        ...Object.keys(before || {}),
        ...Object.keys(after || {}),
    ])).sort();

    return keys.map(k => {
        const b = before?.[k];
        const a = after?.[k];
        const changed = JSON.stringify(b) !== JSON.stringify(a);
        return { key: k, before: b, after: a, changed };
    });
};

const fmt = (v: any) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
};

const LogPreview = ({ log, onClick }: { log: Log | null, onClick: () => void }) => {
    const { t } = useTranslation();

    if (!log) return null;

    const rows = toRows(log.before, log.after);
    const hasBefore = !!log.before && Object.keys(log.before).length > 0;
    const hasAfter = !!log.after && Object.keys(log.after).length > 0;

    return (
        <div className="container-log-preview p-2 rounded-1">
            <button type='button' className='btn-close custom-close' aria-label='Close' onClick={onClick} style={{ color: 'var(--text-primary)' }}> </button>
            <div className="d-flex justify-content-between align-items-end mb-2 p-1">
                <div>
                    <div className="h4 mb-1">{t("ChangesIn")} {log.objectName}</div>
                    <div className="h5 text-muted small">ID: {log.objectID}</div>
                </div>
            </div>
            <div className="row g-3">
                <div className="col-12 col-md-6">
                    <div className="preview-card rounded-1 p-2">
                        <div className="preview-title h6 mb-2">{t("PreviousState")}</div>
                        {hasBefore ? (
                            <div className="table-responsive">
                                <table className="table table-sm table-borderless align-middle mb-0 preview-table">
                                    <tbody>
                                        {rows.map(r => (
                                            <tr key={`before-${r.key}`} className={r.changed ? "is-changed" : ""}>
                                                <th className="w-50">{r.key}</th>
                                                <td className="text-break">{fmt(r.before)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-muted small">{t("NoData")}</div>
                        )}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="preview-card rounded-1 p-2">
                        <div className="preview-title h6 mb-2">{t("ActualState")}</div>
                        {hasAfter ? (
                            <div className="table-responsive">
                                <table className="table table-sm table-borderless align-middle mb-0 preview-table">
                                    <tbody>
                                        {rows.map(r => (
                                            <tr key={`after-${r.key}`} className={r.changed ? "is-changed" : ""}>
                                                <th className="w-50">{r.key}</th>
                                                <td className="text-break">{fmt(r.after)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-muted small">{t("NoData")}</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogPreview;
